import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import { AllegroIsHere, FooterDesktop } from "../../../shared";
import HeresHowItWorks from "./heresHowItWorks";
import Video from "../../../shared/components/video";
import useLocaleContext from "src/components/shared/context/useLocaleContext";
import { getVideoSourceByLanguage } from "src/components/shared/utils/utils";
import FAQ from "./FAQ";
import "./home.scss";

const Home = () => {
  const { language } = useLocaleContext();
  const videoSource = getVideoSourceByLanguage(language);

  return (
    <Column
      className="background"
      spacing="none"
      heights={["fill", "fill", "100px"]}
    >
      <Column spacing="600" heights={["fill"]}>
        <AllegroIsHere></AllegroIsHere>
        <Column spacing="400">
          <Row></Row>
          <Video widthRatio={0.7} src={videoSource}></Video>
        </Column>
        <HeresHowItWorks />
        <Column height="3em"></Column>
      </Column>
      <FAQ></FAQ>
      <FooterDesktop></FooterDesktop>
    </Column>
  );
};

export default Home;
